import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser'
import { AloSecurityItem } from '@/models/alo/AloSecurityItem'
import { getDefaultSecurityRights } from '@/enum/SecurityItems'
import { AloPersonne, getDefaultAloPersonne } from '@/models/alo/AloPersonne'

export interface IAuthState {
  token: string
  authStatus: string
  userStatus: string
  userProfile: AloPersonne
  renewTokenId: number
  userSecurity: { [index: string]: AloSecurityItem}
  redirectPath: string
}

//Initial State
const state: IAuthState = {
  token: localStorage.getItem('user-token') || '',
  authStatus: '',
  userStatus: '',
  userProfile: getDefaultAloPersonne(),
  renewTokenId: 0,
  userSecurity: getDefaultSecurityRights(),
  redirectPath: '/'
}
export default state